import React, { useState, useEffect } from "react";
import CenterUI from "./CenterUI";
import { isMobile } from "react-device-detect";

const WarningComponent = ({ onContinue, config }) => (
    <div className = "fullscreen-popup" style ={{backgroundColor:`rgba(0,0,0,0)`}}>
      <div className="warning-component">
        <h2>Optimized for Desktop</h2>
        <p>This content is optimized for desktop viewing. For the best experience, please switch to a desktop device.</p>
        <button onClick={onContinue} >
          Continue Anyway
        </button>
      </div>
    </div>
);

const PlaceHolder = ({hideUI}) =>(
  <div className="mainElem">
      <div className="CenterUI"> 
        {hideUI ?  <></>: <div className="UI-main"></div>}
        <div className="IframeComponent"></div>
      </div>
  </div>
)

  
function MobileWarningModal({ config }) {
    const skip = config.skipMobileWarning;
    const [showIframe, setShowIframe] = useState(skip || false);
  
    useEffect(() => {
      if (!isMobile) {
        setShowIframe(true);
      }
    }, []);
  
    const handleContinue = () => {
      setShowIframe(true);
    };
  
    return (
      <>
        {showIframe ? <CenterUI config = {config} /> : <> <PlaceHolder hideUI = {config.hideUI}/> <WarningComponent onContinue={handleContinue} config = {config}/> </>}
      </>
    );
  }
  
  export default MobileWarningModal;